export const de = {
  homePage: {
    helloWorld: 'Hi, how you doin?',
    countable: 'no count | one count | 2nd thing | {count} thingy',
    variablesOne: 'First var: {0}, Second var: {1}'
  },
  'homePage.variablesTwo': 'First var: {one}, Second var: {two}',
  nav: {
    model: 'Modelle',
    details: 'Einzelheiten',
    summary: 'Zusammenfassung',
    preview: 'Vorschau',
  },
  footer:{
    total: 'Gesamt: {price} (ohne MwSt.)',
    next: 'Weiter',
    submit: 'Zur Kasse',
    finish: 'Anfrage senden',
    back: 'Zurück'
  },
  model: {
    selectModel: 'Modell auswählen'
  },
  details: {
    editItem: 'Gestalten Sie Ihren Stuhl',
    tooltip: `Ausgewählte Materialien sind nur auf Anfrage erhältlich. <br />  <br /> Wir laden Sie ein, sich die Muster unter dem Link <a href="https://vez-sedezi.si/de/moeglichkeiten/" target="#" class="underline">https://vez-sedezi.si/de/moeglichkeiten/</a> anzusehen und uns zu kontaktieren, sodass wir gemeinsam die beste Option für Sie auswählen können.`,
    tooltipOk: 'OK',
    noBackrestUpholstery: 'Keine gepolsterte Rückenlehne',
    backrest: 'Rückenlehne',
    upholstered: 'Gepolstert',
    notUpholstered: 'Nicht gepolstert',
    options: 'keine Option | 1 Option | {options} Optionen',
    loadingModel: 'Zeichnung im Gange...',
    colorWarning: 'Farbmuster auf Ihrem Computer können von der tatsächlichen Situation abweichen.'
  },
  maps: {
    bugy: {
      legs: 'Beine',
      seat: 'Sitz',
      seatingAndBackrest: 'Polsterung'
    },
    barly: {
      legs: 'Beine',
      seat: 'Sitz',
      seatingAndBackrest: 'Polsterung'
    },
    barman: {
      seat: 'Sitz',
      seatingAndBackrest: 'Polsterung'
    },
    kuki: {
      legs: 'Beine',
      seat: 'Sitz',
      seatingAndBackrest: 'Polsterung'
    },
    praktik: {
      seat: 'Sitz',
      seatingAndBackrest: 'Polsterung'
    },
    scorpio: {
      legs: 'Beine',
      seat: 'Sitz',
      seatingAndBackrest: 'Polsterung',
      legsShape: 'Beinform'
    }
  },
  summary: {
    summary: 'Zusammenfassung',
    send_inquiry: 'Anfrage senden',
    message: 'Es ist auch möglich, einen einzelnen Stuhl zu kaufen. Bei abweichenden Wünschen ändert sich der Preis je nach Materialwahl und Menge. Fügen Sie dem Kommentar Ihre Wünsche hinzu.',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    duplicate: 'Duplizieren',
    addNewProduct: 'Neuen Stuhl hinzufügen',
    card: {
      pricePerItem: '{price} / Stuhl (ohne MwSt.)'
    }
  },
  preview: {
    summary: 'Auschecken',
    vatBasis: 'MwSt.-Bemessungsgrundlage',
    vat: 'MwSt.',
    totalPrice: 'Gesamtpreis',
    yourInfo: 'Ihre Angaben',
    delivery: 'Lieferung',
    freeDelivery: 'Nach Vereinbarung.',
    payment: 'Zahlung',
    price: {
      free: 'Kostenlose Lieferung',
      formatted: '{price}'
    },
  },
  done: {
    thankYou: 'Vielen Dank für Ihr Vertrauen!',
    done1: 'Wir haben Ihre Anfrage angenommen.',
    done2: 'Möchten Sie mehr über maßgeschneiderte Stühle von Vez erfahren?',
    done3: 'Wir laden Sie ein, unsere Website zu besuchen.',
    back: 'Zurück zur Startseite'
  },
  inputs: {
    comment: 'Kommentare',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Telefonnummer',
    mail: 'E-mail',
    address: 'Adresse',
    post: 'Postleitzahl',
    city: 'Stadt',
    businessReceipt: 'Firmenrechnung',
    taxId: 'MwSt-Identifikationsnummer  ',
    company: 'Name des Unternehmens'
  },
  errors: {
    firstName: 'Name ist erforderlich',
    firstNameLength: 'Der Name muss mindestens {length} Zeichen enthalten',
    lastName: 'Nachname ist erforderlich',
    lastNameLength: 'Der Nachname muss mindestens {length} Zeichen enthalten',
    phone: 'Telefonnummer ist erforderlich',
    phoneValid: 'Telefonnummer hat nicht das richtige Format',
    mail: 'E-Mail ist erforderlich',
    mailValid: 'E-Mail ist ungültig',
    address: 'Adresse ist erforderlich',
    post: 'Postleitzahl ist erforderlich',
    city: 'Postort ist erforderlich',
    company: 'Firmenname ist erforderlich',
    taxId: 'MwSt-Identifikationsnummer ist erforderlich',
    delivery: 'Lieferung ist erforderlich'
  },
  payment:{
    later: 'Einfach verlangen',
    now: 'Ich möchte jetzt bezahlen'
  }

};

export const currencyDeDE = {
  currency: {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol'
  }
}
